import { parseVolumeJwt } from "@/lib/auth";

/**
 * The FX MCP server is merchant-only. Admins impersonating a merchant still
 * hold an admin token, which the server refuses, so they do not get the page.
 */
export const canManageFxMcp = (context: {
  readonly accessToken: string;
  readonly authorities: readonly string[];
}) =>
  !parseVolumeJwt(context.accessToken).adminId &&
  context.authorities.includes("EDIT_SETTINGS");
